import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { FORM_FIELDS } from "../../Constants";
import AddPosModal from "./AddPosModal";
import { Button } from "react-bootstrap";

const PosTable = ({ data, setData }) => {
  const { STORE_DATA } = FORM_FIELDS;

  const [showAddPosModal, setShowAddPosModal] = useState(false);
  const [posModalUpdateData, setPosModalUpdateData] = useState(null);

  return (
    <fieldset className="scheduler-border">
      {setData && (
        <>
          <legend className="scheduler-border d-flex justify-content-between align-items-center">
            Blagajne
            <Button
              onClick={() => {
                setShowAddPosModal(true);
              }}
            >
              Dodaj blagajnu
            </Button>
          </legend>
        </>
      )}
      <BootstrapTable
        keyField="name"
        data={data}
        columns={[
          {
            dataField: "id",
            text: "RBR",
            hidden: !setData,
          },
          {
            dataField: STORE_DATA.POS_DATA.TAG.name,
            text: STORE_DATA.POS_DATA.TAG.title,
          },
          {
            dataField: STORE_DATA.POS_DATA.INVENTORY_NUMBER.name,
            text: STORE_DATA.POS_DATA.INVENTORY_NUMBER.title,
          },
          {
            dataField: STORE_DATA.POS_DATA.DOCUMENT_NUMBER.name,
            text: STORE_DATA.POS_DATA.DOCUMENT_NUMBER.title,
          },
          {
            dataField: STORE_DATA.POS_DATA.DEPOSIT.name,
            text: STORE_DATA.POS_DATA.DEPOSIT.title,
          },
          {
            dataField: STORE_DATA.POS_DATA.MSISDN.name,
            text: STORE_DATA.POS_DATA.MSISDN.title,
          },
          {
            dataField: STORE_DATA.POS_DATA.POS_SERIAL_NUMBER.name,
            text: STORE_DATA.POS_DATA.POS_SERIAL_NUMBER.title,
          },
          {
            dataField: "id",
            text: "",
            hidden: !setData,
            formatter: (cell, row) => {
              return (
                <>
                  <Button
                    className="btn btn-outline-secondary"
                    title="Ukloni blagajnu"
                    onClick={() =>
                      setData((x) => x.filter((x) => x.id !== cell))
                    }
                  >
                    <span className="icon icon-trash mr-2"></span>
                  </Button>
                  <Button
                    className="btn btn-outline-secondary mr-2"
                    title="Uredi blagajnu"
                    onClick={() => {
                      setShowAddPosModal(true);
                      setPosModalUpdateData(row);
                    }}
                  >
                    <span className="icon icon-edit"></span>
                  </Button>
                </>
              );
            },
          },
        ]}
        noDataIndication={"Nema podataka"}
      />
      {showAddPosModal && (
        <AddPosModal
          show={showAddPosModal}
          updateData={posModalUpdateData}
          posData={data}
          addRecord={(x) => {
            const id = data?.[data?.length - 1]?.id + 1 || 1;
            setData([...data, { ...x, id }]);
          }}
          editRecord={(id, x) => {
            const index = data.findIndex((item) => item.id === id);
            if (index === -1) return;
            const newData = [...data];
            newData[index] = { ...x, id };
            setData(newData);
          }}
          handleHide={() => {
            setShowAddPosModal(false);
            setPosModalUpdateData(null);
          }}
        />
      )}
    </fieldset>
  );
};

export default PosTable;
